import { dynatraceCustomError, dynatraceCustomTrack } from '@nav-patient-front/dynatrace'

type LocalStorageItem<T> = {
    value: T | null
    error: Error | null
}

const localStorageUtil = {
    get: function <T>(key: string): LocalStorageItem<T> {
        try {
            const item = localStorage.getItem(key)
            let parsed: T | null = null
            if (item) {
                parsed = JSON.parse(item) as T
                return { value: parsed as T, error: null }
            }
            dynatraceCustomTrack(`[npac-webplatform-front-global] Chave ${key} não existe no localstorage`)
            return { value: null, error: new Error(`Missing key=${key} in localStorage.`) }
        } catch (error) {
            dynatraceCustomError(`[npac-webplatform-front-global] Erro ao buscar chave ${key} no localstorage: ${error}`)
            return { value: null, error: new Error(error.message) }
        }
    },
    set: function <T>(key: string, value: T): null | Error {
        try {
            const item = JSON.stringify(value)
            localStorage.setItem(key, item)
            return null
        } catch (error) {
            dynatraceCustomError(`[npac-webplatform-front-global] Erro ao guardar chave ${key} no localstorage: ${error}`)
            return new Error(error.message)
        }
    },
    remove: function (key: string | string[]) {
        const keyList = Array.isArray(key) ? key : [key];
        keyList.forEach(key => localStorage.removeItem(key));
    }
}

export default localStorageUtil
